/**
 * /m/chat — Agent Portal (native-shell WebUI).
 * Visual design: docs/design/chatgpt_mobile_design_prototype.tsx
 */

import { AgentPortal } from '@/components/m-portal/agent-portal'

export default function MobileChatRoute(): JSX.Element {
  return <AgentPortal />
}
